import React from 'react';
import {Box, Paper, Typography} from '@mui/material';

interface PlaceholderEditorProps {
    tabObject?: {
        objectType: string;
        object?: {
            name?: string;
        };
    };
}

/**
 * Placeholder editor component for resource types that don't have a specific editor yet
 */
export default function PlaceholderEditor(props: PlaceholderEditorProps): React.ReactElement {
    const { tabObject } = props;
    
    return (
        <Box sx={{ p: 3 }}>
            <Paper elevation={2} sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>
                    {tabObject?.object?.name || 'New Resource'}
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    Editor for {tabObject?.objectType} is not yet implemented.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    This is a placeholder screen.
                </Typography>
            </Paper>
        </Box>
    );
}